import React from "react";
import PropTypes from "prop-types";
import ErrorsContext from "./contexts/ErrorsContext";
import OperationContext from "./contexts/OperationContext";
import ResourceContext from "./contexts/ResourceContext";
import OperationsContext from "./contexts/OperationsContext";
import shortid from "shortid";

class Operation extends React.Component {

    static contextType = OperationsContext;

    componentDidMount() {

        this.uuid = shortid.generate();

        const {proxy, parentOperation} = this.props;

        if (proxy === true && this.receivedValidOperation) {
            this.operation.meta = parentOperation.meta;

            parentOperation.onExecute(this.uuid, () => {
                this.operation.meta = parentOperation.meta;
            });

            this.operation.parent = parentOperation;
        }
    }

    componentWillUnmount() {

        const operation = this.operation
        if(operation && typeof operation.abort === 'function') {
            operation.abort();
        }

        const {proxy, parentOperation} = this.props;

        if (proxy === true && this.receivedValidOperation) {
            parentOperation.unsetOnExecuteCallback(this.uuid);
        }
    }

    /////////////////////////////////
    // Configuration
    /////////////////////////////////

    static get defaultProps() {
        return {
            operationContext: {},
            persist: false,
            provideErrors: true,
        };
    }

    static get propTypes() {
        return {
            operationContext: PropTypes.any,
            persist: PropTypes.bool,
            provideErrors: PropTypes.bool,
        };
    }

    /////////////////////////////////
    // Helpers to generate desired operation slug
    /////////////////////////////////

    get namespace() {
        const {namespace, operation} = this.props;

        if (namespace) return namespace;

        if (operation && operation.resource) {
            return operation.resource.namespace;
        }

        return 'api';
    }

    get resourceName() {
        const {resourceName, operation} = this.props;

        return resourceName || operation.resource.slug;
    }

    get operationName() {
        const {operationName, operation} = this.props;

        return operationName || operation.slug;
    }

    get operationContext() {
        let context = {...this.props.operationContext};

        if(this.props.proxy === true) {
            context.proxy = true;
        }

        if(this.props.persist === true) {
            context.persist = true;
        }

        return context;
    }

    /////////////////////////////////
    // Operation instance getters
    /////////////////////////////////

    get receivedValidOperation() {
        const {parentOperation} = this.props;

        return parentOperation && typeof parentOperation === 'object' && Object.keys(parentOperation).length > 0;
    }

    get repository() {
        const operations = this.context;

        if (operations) return operations;

        throw new Error('Unable to find the Operation Repository.');
    }

    get resource() {
        return this.operation.resource;
    }

    get operation() {
        return this.repository.get(this.namespace, this.resourceName, this.operationName, this.operationContext, {proxy: this.props.proxy, persist: this.props.persist});
    }

    /////////////////////////////////
    // Rendering
    /////////////////////////////////

    render() {
        return (
            <ResourceContext.Provider value={this.resource} >
                <OperationContext.Provider value={this.operation} >
                    {this.props.provideErrors === true ? (
                        <ErrorsContext.Provider value={this.operation.errors} >
                            <React.Fragment>
                                {this.props.children}
                            </React.Fragment>
                        </ErrorsContext.Provider>
                    ) : (
                        <React.Fragment>
                            {this.props.children}
                        </React.Fragment>
                    )}
                </OperationContext.Provider>
            </ResourceContext.Provider>
        );
    }

}

export default Operation;
